export default {
  description:
    'Téléversez les documents nécessaires pour vérifier votre entreprise. Les documents obligatoires sont indiqués ; vous pouvez ajouter les facultatifs maintenant ou plus tard.',
  missing_one:
    "Un document obligatoire est encore manquant. Vous pouvez continuer : cette étape reste ouverte jusqu'à son téléversement.",
  missing_other:
    "{{count}} documents obligatoires sont encore manquants. Vous pouvez continuer : cette étape reste ouverte jusqu'à leur téléversement.",
  buttons: {
    back: 'Retour',
    next: 'Suivant',
    finish_later: 'Terminer plus tard',
  },
};
